import { render, staticRenderFns } from "./KeuanganDashboard.vue?vue&type=template&id=5f8f5a96&scoped=true"
import script from "./KeuanganDashboard.vue?vue&type=script&lang=js"
export * from "./KeuanganDashboard.vue?vue&type=script&lang=js"
import style0 from "./KeuanganDashboard.vue?vue&type=style&index=0&id=5f8f5a96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8f5a96",
  null
  
)

export default component.exports